import React from "react";
import GridValueProp from "./GridValueProp";
import CardValueProp from "./CardValueProp";
import CardValuePropDivider from "./CardValuePropDivider";
import ValuePropIntro from "../ValuePropIntro";

export default function MessageValueProp(props) {
    const {siteConfig, messages, vpConfig: config, ...other} = props
    const maxTitleLength = Math.max(...messages.map(m => m.title ? m.title.length : 0))

    return (<div>
        <ValuePropIntro {...other}/>
        <div className="row">
            {messages.map((message, index, messages) => {
                const isCardEnabled = config?.type === "card"

                if (config?.type === "grid") {
                    return <GridValueProp {...message} config={config} reverse={index % 2 === 1}/>;
                }


                return (
                    <div key={`vp-${index}`}>
                        <CardValueProp
                            isCardEnabled={isCardEnabled}
                            siteConfig={siteConfig}
                            {...message}
                            maxTitleLength={maxTitleLength}
                            config={config}
                            reverse={index % 2 === 1}
                        />
                        {!isCardEnabled && <CardValuePropDivider len={messages.length} index={index}/>}
                    </div>
                );
            })}
        </div>
    </div>)
}
